// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"src-hellospa-components-prep-and-send-embedded-styles__loadingContainer--2XK_F"};